/** When your routing table is too long, you can split it into small modules **/

import Layout from "@/layout";

const maintainRouter = {
  path: "/pointsManage",
  component: Layout,
  redirect: "/pointsManage/index",
  name: "pointsManage",
  meta: {
    title: "积分管理",
    icon: "clipboard"
  },
  children: [
    {
      path: "/pointsChangeList",
      name: "pointsChangeList",
      component: () => import("@/views/pointsManage/pointsChangeList"),
      meta: {
        title: "积分变更明细列表",
        icon: "clipboard"
      },
      hidden: true
    }
  ]
};

export default maintainRouter;
